module.exports = __webpack_public_path__ + "static/media/empty-bg.e40ad70e.svg";